

export const dataGridStyle = (headerGroupedHeight: string) => ({
    border: 'none',
    '& .MuiDataGrid-virtualScroller': {
        overflowY: 'scroll !important',
        maxHeight: '48vh',
        border: '1px solid #DDDDDD',
        borderTop: 'none',
    },
    '& .MuiDataGrid-toolbarContainer': {
        padding: '5px',
        marginBottom: '10px',
    },
    '& .MuiDataGrid-columnHeaders, & .MuiDataGrid-pinnedColumnHeaders': {
        backgroundColor: '#f1f1f1',
        border: '1px solid #DDDDDD',
        borderBottom: 'none',
        borderRadius: '0',
        maxHeight: `${headerGroupedHeight} !important`,
        height: headerGroupedHeight,
    },
    '& .MuiDataGrid-row, & .MuiDataGrid-cell': {
        minHeight: '45px !important',
        maxHeight: '45px !important',
        height: '45px',
    },
    '& .MuiDataGrid-row--editing .MuiDataGrid-cell--editing': {
        border: '2px solid #0d0d0d',
    },
    '& .MuiDataGrid-footerContainer': {
        border: '1px solid #DDDDDD',
        borderTop: 'none',
    },
    '& .MuiDataGrid-cell--editable, .MuiDataGrid-footerContainer': {
        minHeight: '45px !important',
        maxHeight: '45px !important',
        height: '45px',
        '& .MuiDataGrid-cellContent': {
            border: '1px solid #CCCCCC',
            borderRadius: '0.2em',
            padding: '5px',
            margin: '10%',
            width: '80%',
            height: '80%',
        },
    },
    '& .MuiButton-root, & .MuiIconButton-root, .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
    },
    '& .grouped-header': {
        marginTop: '20px',
        '& .MuiDataGrid-columnSeparator': {
            marginTop: '0',
        },
    },
    '& .lead-group-header': {
        '& .MuiDataGrid-columnSeparator, & .MuiDataGrid-iconButtonContainer, & .MuiDataGrid-menuIcon': {
            marginTop: '20px',
        },
    },
    '& .light-blue-header': {
        backgroundColor: '#ddebf7',
        height: headerGroupedHeight,
    },
});